import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPlaybooksTemplateCreateRoute: InvariantJiraRoute = {
	name: 'project-settings-playbooks-template-create',
	path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/template/:templateId',
	exact: true,
};
